<template>
    <swiper :options="{
        autoplay: true,
        pagination: {
            el: '.j_swiper-pagination',
            clickable: true
        }
    }">
        <SwiperSlide v-for="(item, index) in items" :key="index">
            <a class="block" :href="item.url" :title="item.title" :target="item.target"><img class="rounded object-cover" :class="{img_height: type === 'original_home'}" :alt="item.title"
                    :src="item.path_url" /></a>
        </SwiperSlide>
        <div class="j_swiper-pagination swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import usePlatformAdvertBanner from '~/composables/usePlatformAdvertBanner';

export default defineComponent({
    name: 'PlatformAdvertStairSwiper',
    components: {
        Swiper,
        SwiperSlide
    },
    props: {
      type: {
        type: [String, Number]
      },
      items: {
        type: Array,
        default: () => []
      }
    },
    // props: {
    //     items: {
    //         type: Array,
    //         default: () => ([])
    //     }
    // },
//     setup(props) {
//         const { state: items } = usePlatformAdvertBanner(props.type);
//         return {
//             items
//         }
//     }
})
</script>

<style lang="scss" scoped>

.img_height{
  height: 360px;
  width: 100%;
}

</style>
